import { ButtonBase, Tooltip } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import React, { ReactNode } from "react";
import { makeStyles } from "tss-react/mui";
import QuestionIcon from "~/features/icon/Question.svg";
import { colors } from "~/theme";

const useStyles = makeStyles()({
    customTooltip: {
        backgroundColor: colors.black,
    },
    customArrow: {
        color: colors.black,
    },
});

export function IconButtonTooltip({
    text,
    icon = <QuestionIcon />,
    open,
    TransitionComponent,
}: {
    text: string;
    icon?: ReactNode;
    open?: boolean;
    TransitionComponent?: React.ComponentType<
        TransitionProps & { children?: React.ReactElement }
    >;
}) {
    const { classes } = useStyles();

    return (
        <Tooltip
            open={open}
            classes={{
                tooltip: classes.customTooltip,
                arrow: classes.customArrow,
            }}
            arrow
            title={text}
            TransitionComponent={TransitionComponent}
        >
            <ButtonBase>{icon}</ButtonBase>
        </Tooltip>
    );
}
